/* eslint-disable no-lone-blocks */
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Button from "@mui/material/Button";
import { CmpInputField, CmpSelectArrField } from "../ToolBox/ToolBox";
import "./ReuseableComponent.css";
import { CmpTextFieldV1 } from "../ToolBox/ToolBoxV1";
import { DataGridPro } from "@mui/x-data-grid-pro";

const columns = [
  { field: "col1", headerName: "Column 1", width: 150 },
  { field: "col2", headerName: "Column 2", width: 150 },
];
const GCToggleSearchV1 = ({
  xName = "",
  xType = "text",
  xValue = "",
  xReadOnly = true,
  xOnChange = () => {},
  xOnKeyUp = () => {},
  xError = false,
  xErrorMessage = "",
  xMediaQuery = false,
  xonClickbtn = () => {},
  xrows = [],
  xcolumns = [],
  xRowCellClick = () => {},
  xRowClick = () => {},
  xToggle = false,
  xData = [],
  xOnChangeDropdownInput = () => {},
  xDropdownObj = "",
  xOnKeyUpDropdownInput = () => {},
  xtabIndex = "",
  xid = "table-main-grid-dropdown-Toggle",
  xref = "",
  xLabelText = "PartyName",
  xSize = "small",
  xDisabled = false,
  xSx = {},
}) => {
  const fDummy = () => {};

  return (
    <span className={"toggleSearch"}>
      <div className="d-flex ">
        <CmpTextFieldV1
          xLabelText={xLabelText}
          xSize={xSize}
          xref={xref}
          xtabIndex={xtabIndex}
          xValue={xValue}
          xType={xType} // text/number/password
          xName={xName}
          xReadOnly={xReadOnly}
          xDisabled={xDisabled}
          xOnChange={xOnChange ? xOnChange : fDummy}
          xOnKeyUp={!!xOnKeyUp ? xOnKeyUp : fDummy}
          xError={xError}
          xErrorMessage={""}
          xSx={xSx}
        />
        <Button
          onClick={xonClickbtn ? xonClickbtn : fDummy}
          variant="outlined"
          disabled={xReadOnly}
          className="btn-text-transform-none"
          sx={{
            minWidth: "40px",
            paddingTop: "0px !important",
            paddingBottom: "0px !important",
          }}
        >
          <MoreHorizIcon fontSize="small" />
          {/* <i className="fas fa-caret-down"></i> */}
        </Button>
      </div>
      {xError ? <div className="danger"> {xErrorMessage}</div> : ""}
      {xToggle ? (
        <div className="toggleSearchAbsolute">
          <div className=" border h-100">
            <Grid container spacing={0} className="my-2">
              <Grid item xs={3}>
                {/* <CmpSelectArrField
                  xLabelText="Type"
                  xValue={xData.length > 0 ? xDropdownObj.Type : ""}
                  xOnChange={xOnChangeDropdownInput}
                  xName={"Type"}
                  xData={xData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                /> */}
                <select
                  // className="form-select form-select-sm sales-invoice-filter-select"
                  style={{ width: "100%", height: "100%" }}
                  name="Type"
                  value={xData.length > 0 ? xDropdownObj.Type : ""}
                  onChange={xOnChangeDropdownInput}
                >
                  {xData.length > 0 ? (
                    <>
                      {" "}
                      {xData?.map((value, index) => (
                        <option
                          className="py-2"
                          value={value}
                          key={"WmsStatus" + index}
                        >
                          {value}
                        </option>
                      ))}{" "}
                    </>
                  ) : (
                    <option value="">none</option>
                  )}
                </select>
              </Grid>
              <Grid item xs={7}>
                <div
                  style={{ height: "100%" }}
                  className="sales-invoice-search-input"
                >
                  <CmpInputField
                    xValue={xDropdownObj.Data}
                    xType={"text"} // text/number/password
                    xName={"Data"}
                    xReadOnly={false}
                    xOnChange={!!xOnChange ? xOnChangeDropdownInput : fDummy}
                    xOnKeyUp={!!xOnKeyUp ? xOnKeyUpDropdownInput : fDummy}
                    xError={false}
                    xErrorMessage={""}
                  />
                </div>
              </Grid>
              <Grid item xs={2}>
                <Button
                  onClick={
                    !!xOnKeyUpDropdownInput ? xOnKeyUpDropdownInput : fDummy
                  }
                  variant={"contained"}
                  disabled={false}
                  size={"small"}
                  className="btn-text-transform-none"
                  sx={{
                    paddingBottom: "2px !important",
                    paddingTop: "2px !important",
                  }}
                >
                  Load
                </Button>
              </Grid>
            </Grid>
            <div id={xid} className="search-grid-table  w-100 GCDropDowmSearch">
              <Box className="w-100" sx={{ height: 200 }}>
                <DataGridPro
                  rowHeight={30}
                  headerHeight={30}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                    "& .MuiDataGrid-root": {
                      fontSize: "10px !important", // Global font size for the grid
                    },
                    "& .MuiDataGrid-cell": {
                      fontSize: "10px", // Font size for the cells
                      lineHeight: "1 !important", // Ensure line height is compact
                      padding: "0px !important", // Remove extra padding inside cells
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      fontSize: "10px", // Font size for headers
                      padding: "0px !important", // Remove extra padding inside headers
                    },
                    "& .MuiDataGrid-row": {
                      minHeight: "25px !important", // Force the row height to remain small
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "10px !important", // Ensure column header text is small
                      overflow: "hidden", // Prevent text from overflowing
                      whiteSpace: "nowrap", // Force text to remain on one line
                    },
                    "& .MuiDataGrid-cellContent": {
                      fontSize: "10px !important", // Font size for actual content within cells
                    },
                  }}
                  rows={xrows}
                  columns={xcolumns.length > 0 ? xcolumns : columns}
                  onCellKeyDown={xRowCellClick ? xRowCellClick : fDummy()}
                  onRowClick={xRowClick ? xRowClick : fDummy()}
                  // hideFooter={xrows.length < 100}
                  hideFooter={true}
                />
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </span>
  );
};

export default GCToggleSearchV1;
